/** Shows if the specified `variant` is one of snackbar base variant's. */
export const isSnackbarBaseVariant = (variant) => variant === 'default' ||
    variant === 'error' ||
    variant === 'info' ||
    variant === 'success' ||
    variant === 'warning' ||
    variant === 'reconnect';
